"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const FA5Font_1 = require("./FA5Font");
const Circle = (props) => {
    const { primaryColor, secondaryColor, embedFont, globalScaleFactor, alphaNumericCharacter, alphaNumericScale, symbolFontName, sizeScale } = props;
    const dimension = 20 * globalScaleFactor; //TODO: ensure that web uses 20 and mobile uses 40 as a basis
    const center = dimension / 2;
    const radius = alphaNumericCharacter ? dimension / 3 : (dimension * 2) / 9;
    const fontSize = 0.4 * (alphaNumericScale || 1) * dimension;
    const fontFamily = symbolFontName || (embedFont && '"Font Awesome 6 Pro"') || undefined;
    const isFontAwesome = ((alphaNumericCharacter === null || alphaNumericCharacter === void 0 ? void 0 : alphaNumericCharacter.charCodeAt(0)) || 0) > 0xf000;
    return `
    <svg
      width="${dimension}"
      height="${dimension}"
      view-box="0 0 ${dimension} ${dimension}"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
    ${embedFont
        ? `
      <defs>
        <style type="text/css">${FA5Font_1.FA5Font}</style>
      </defs>
    `
        : ''}
      <g>
        <ellipse
          cx="${center}"
          cy="${center}"
          rx="${radius}"
          ry="${radius}"
          fill="${alphaNumericCharacter ? (secondaryColor ? `#${secondaryColor}` : '#fff') : `#${primaryColor}`}"
          stroke="${alphaNumericCharacter ? `#${primaryColor}` : (secondaryColor ? `#${secondaryColor}` : '#fff')}"
          stroke-width="${(1 / 16) * dimension / (sizeScale || 1)}"
        />
        ${alphaNumericCharacter
        ? `
          <text
            x="50%"
            y="50%"
            text-anchor="middle"
            alignment-baseline="central"
            dominant-baseline="middle"
            fill='#${primaryColor}'
            font-size='${fontSize}'
            ${fontFamily ? `font-family='${fontFamily}'` : ''}
            font-weight="${isFontAwesome ? 900 : 400}"
          >${alphaNumericCharacter}</text>`
        : ''}
      </g>
    </svg>`;
};
exports.default = Circle;
//# sourceMappingURL=CircleBuilder.js.map